import { gql } from "@apollo/client";

// Query to get affiliate data by user ID (for affiliate portal)
export const AFFILIATE_BY_USER = gql`
  query AffiliateByUser($user_id: uuid!) {
    approved_commissions_sum: affiliate_commissions_aggregate(
      where: {
        status: { _eq: "APPROVED" }
        reward_type: { _eq: "POINTS" }
        affiliate: { fk_user_id: { _eq: $user_id } }
      }
    ) {
      aggregate {
        sum {
          points_awarded
        }
      }
    }
    affiliates(
      where: { fk_user_id: { _eq: $user_id } }
      limit: 1
    ) {
      id
      affiliate_code
      status
      reward_type
      points_per_referral
      total_points_earned
      pending_points
      redeemed_points
      total_referrals
      bank_account_name
      bank_account_number
      payment_method
      created_at
      updated_at
      user {
        id
        username
        phone
      }
      affiliate_referrals_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

// Mutation to update affiliate payment info (for affiliate portal)
export const UPDATE_AFFILIATE_PAYMENT_INFO = gql`
  mutation UpdateAffiliatePaymentInfo(
    $id: uuid!
    $bank_account_name: String
    $bank_account_number: String
    $payment_method: String
  ) {
    update_affiliates_by_pk(
      pk_columns: { id: $id }
      _set: {
        bank_account_name: $bank_account_name
        bank_account_number: $bank_account_number
        payment_method: $payment_method
      }
    ) {
      id
      bank_account_name
      bank_account_number
      payment_method
      updated_at
    }
  }
`;

// Query to get affiliate redemptions with date range and pagination
export const AFFILIATE_REDEMPTIONS = gql`
  query AffiliateRedemptions(
    $fk_affiliate_id: uuid!
    $startDate: timestamptz
    $endDate: timestamptz
    $limit: Int!
    $offset: Int!
  ) {
    affiliate_point_redemptions(
      where: {
        fk_affiliate_id: { _eq: $fk_affiliate_id }
        requested_at: { _gte: $startDate, _lte: $endDate }
      }
      order_by: { requested_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      points_redeemed
      redemption_type
      redemption_value
      status
      payment_method
      payment_reference
      notes
      requested_at
      processed_at
      completed_at
    }
    affiliate_point_redemptions_aggregate(
      where: {
        fk_affiliate_id: { _eq: $fk_affiliate_id }
        requested_at: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

// Query to get affiliate commissions with date range and pagination
export const AFFILIATE_COMMISSIONS_PORTAL = gql`
  query AffiliateCommissionsPortal(
    $fk_affiliate_id: uuid!
    $startDate: timestamptz
    $endDate: timestamptz
    $limit: Int!
    $offset: Int!
  ) {
    affiliate_commissions(
      where: {
        fk_affiliate_id: { _eq: $fk_affiliate_id }
        reward_type: { _eq: "POINTS" }
        created_at: { _gte: $startDate, _lte: $endDate }
      }
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      status
      points_awarded
      reward_type
      created_at
      transaction {
        id
        amount
        status
        user {
          username
          phone
        }
      }
    }
    affiliate_commissions_aggregate(
      where: {
        fk_affiliate_id: { _eq: $fk_affiliate_id }
        reward_type: { _eq: "POINTS" }
        created_at: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

// Query to get affiliate referrals with date range and pagination
export const AFFILIATE_REFERRALS_PORTAL = gql`
  query AffiliateReferralsPortal(
    $fk_affiliate_id: uuid!
    $startDate: timestamptz
    $endDate: timestamptz
    $limit: Int!
    $offset: Int!
  ) {
    affiliate_referrals(
      where: {
        fk_affiliate_id: { _eq: $fk_affiliate_id }
        referred_at: { _gte: $startDate, _lte: $endDate }
      }
      order_by: { referred_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      referred_at
      first_order_completed
      user {
        username
        phone
      }
    }
    affiliate_referrals_aggregate(
      where: {
        fk_affiliate_id: { _eq: $fk_affiliate_id }
        referred_at: { _gte: $startDate, _lte: $endDate }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

// Reuse existing mutation from trainerAffiliation.js
export { CREATE_REDEMPTION_REQUEST } from "../../gql/trainerAffiliation";
